export default __webpack_public_path__ + "static/media/logo-child4.e7a70afc.svg";